module.exports = "//img1.rrcimg.com/_next/static/src/assets/cq_1Y8F8.png";